// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"f8e79026a9aea0a4e05d","655":"a6584f4c154875f3f805"}[chunkId] + ".js";
};